import Vue from 'vue';
import Vuex from 'vuex';

// Vue plugins.
Vue.use(Vuex);
import { users } from './Users';
import { tasks } from './Tasks';
import { profile } from './Profile';
import { rosters } from './Rosters';
import { schedule } from './Schedule';
import { security } from './Security';
import { subjectids } from './SubjectIDs';
const store = new Vuex.Store({
  modules: {
    users,
    tasks,
    profile,
    rosters,
    schedule,
    security,
    subjectids
  }
});
export default store;